import SunMoonMain from "@components/SunMoonMain";
const SunMoon: React.FC = () => {
  return (
    <Container>
      <SunMoonMain />
    </Container>
  );
};

export default SunMoon;
